var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return (_vm.showOverlay)?_c('v-row',{attrs:{"justify":"center"}},[_c('v-col',{attrs:{"cols":"12"}},[_c('v-row',{attrs:{"align":"center"}},[(_vm.shouldShowOverlay)?_c('v-overlay',{attrs:{"absolute":false,"opacity":0.8,"value":_vm.showOverlay}},[_c('a',{directives:[{name:"click-outside",rawName:"v-click-outside",value:(_vm.onClickOutside),expression:"onClickOutside"}],staticStyle:{"width":"440px","height":"248px","display":"block"},attrs:{"href":"#"}},[_c('vue-vimeo-player',{ref:"checkout",attrs:{"options":{
              responsive: true,
              width: 440,
              height: 248,
              autoplay: true,
              pip: true,
              speed: true,
            },"autoplay":true,"speed":true,"video-url":this.checkoutVideoUrl}})],1)]):_vm._e()],1)],1)],1):_vm._e()}
var staticRenderFns = []

export { render, staticRenderFns }